import React, { useEffect, useState } from 'react';
import { useStoreon } from 'storeon/react';
import cnBind from 'classnames/bind';
import classnames from 'classnames';
import { GxIcon } from '@garpix/garpix-web-components-react';
import Burger from '@/components/Burger';
import { ILayoutFilters } from '@/apps/Tasks/interfaces';
import RefreshSVG from '@/assets/Base/refresh.svg';
import useModalFlag from '@/hooks/useModalFlag'
import { ORDERS, TYPES_ORDER } from '@/const';
import { useMediaQuery } from 'react-responsive';
import { api } from '@/api';
import { Events, State } from '@/interfaces';
import SelectType from './SelectType';
import { RANGE_TYPE, TITLES, TYPES_PIPE_OR_WAVE } from '../../consts';
import styles from './styles/index.module.scss';
import { TDayStatistics } from './interfaces';

const defaultTitle = 'Запись на трубу';
const defaultType = TYPES_PIPE_OR_WAVE.PIPE;

const LayoutPipeOrWave: React.FC<ILayoutFilters> = ({ children }) => {
  const cn = cnBind.bind(styles);
  const [type, setType] = useState<TYPES_PIPE_OR_WAVE>(defaultType);
  const {
    dispatch,
    ordersInfo,
    typeOrder,
    ordersDay,
    selectedUser
  } = useStoreon<State, Events>('ordersInfo', 'typeOrder', 'ordersDay', 'selectedUser');
  const [dayStatistic, setDayStatistic] = useState<TDayStatistics>();
  const { flag: flagStatistics, setModalFlag: toggleFlagStatistics } = useModalFlag();

  const isDesktopOrMobile = useMediaQuery({
    query: '(min-width: 568px)'
  })

  const getDayStatistic = async () => {
    const res = await api.order.getDayStatistic({ side: typeOrder, date: ordersInfo?.date });
    setDayStatistic(res)
  }
  const handleClickRefresh = () => {
    dispatch('orders/get');
  }

  useEffect(() => {
    getDayStatistic()
  }, [ordersDay])

  useEffect(()=>{
    handleClickRefresh()
  },[selectedUser])

  useEffect(() => {
    dispatch('typeOrder/set', TYPES_ORDER.PIPE)
  },[])

  const currentType = type.toLowerCase()

  return (
    <>
      <div className={classnames(
        styles['wrapper'],styles[`wrapper--${currentType}`])}
      >
        <div className={styles['wrapper--left_block']}>
          {!isDesktopOrMobile ?  <Burger/> :
            <span>{type ? TITLES[type] : defaultTitle}</span>
          }
        </div>
        <div className={styles['refrech-wrapper']} onClick={handleClickRefresh} role='button' tabIndex={0}>
          <GxIcon
            className={styles['refrech-wrapper--icon']}
            src={RefreshSVG}
          />
          <span className={styles['refrech-wrapper--text']}>Обновить таблицу</span>
        </div>
        <div className={styles['wrapper--right_block']}>
          <SelectType type={type} setType={setType} />
        </div>
      </div>
      {children({})}
      {ordersInfo.range === RANGE_TYPE.day &&
      <div className={styles['footer']}>
        <div className={styles['footer--container']}>
          <div className={styles['footer--group']}>
            <h2 className={styles['statistics--title']}>Статистика за день</h2>
            {flagStatistics &&
            <div className={styles['statistics']}>
              <div className={styles['statistics--labels']}>
                <span className={styles['statistics--labels_item']}>Сумма заявок</span>
                <div className={styles['statistics--item']}>
                <span className={styles['statistics--item_price']}>
                          {dayStatistic && dayStatistic.price_sum.toLocaleString()}
                </span>
                </div>
              </div>
              <div className={styles['statistics--labels']}>
                <span className={styles['statistics--labels_item']}>{typeOrder === ORDERS.WAVE ? 'Общее кол-во сетов заявок' : 'Общее время заявок'}</span>
                <div className={styles['statistics--item']}>
                <span className={styles['statistics--item']}>
                          {dayStatistic && dayStatistic.units_sum.toLocaleString()} {typeOrder === ORDERS.WAVE && 'шт.'}
                </span>
                </div>
              </div>
              {typeOrder === ORDERS.WAVE &&
              <div className={styles['statistics--labels']}>
                <span className={styles['statistics--labels_item']}>Кол-во отработанных часов</span>
                <div className={styles['statistics--item']}>
                <span className={styles['statistics--item']}>
                          {dayStatistic && Number(dayStatistic.total_hours).toLocaleString()} ч.
                </span>
                </div>
              </div>
              }
            </div>
            }
          </div>
          {flagStatistics ?
              <div role='button' tabIndex={0} className={cn(styles['statistics-btn'], styles['statistics-btn_reverse'])}
                   onClick={toggleFlagStatistics}><span>Свернуть</span></div>
              :
              <div role='button' tabIndex={0} className={styles['statistics-btn']}
                   onClick={toggleFlagStatistics}><span>Развернуть</span></div>
          }
        </div>
      </div>
      }
    </>
  );
};

export default LayoutPipeOrWave;
